import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Layout from "../components/Layout.vue";
import ErrorPage from "@/components/404.vue"; // @ is an alias to /src
import usePiniaStore from "@/store/index";
import en from "@/language/en";
import cn from "@/language/zh-cn";
const language: any = localStorage.getItem("language") || "cn";

// 菜单栏的页面meta.form = 菜单栏页面的name
// 非菜单栏的页面meta.form = 所属菜单栏页面的name
export const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/home/person-center",
  },
  {
    path: "/login",
    name: "login",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/login/index.vue"),
    meta: {
      title: language === "cn" ? cn["personalLogin"] : en["personalLogin"], //个人登录
    },
  },
  // 兼容旧的路由模式
  {
    path: "/scan-ticket",
    name: "scan-ticket-legacy",
    component: () =>
      import(
        /* webpackChunkName: "scan-ticket" */ "../views/scan-ticket/index.vue"
      ),
    meta: {
      title: language === "cn" ? cn["orderQRCode"] : en["orderQRCode"], //订单二维码
    },
  },
  // 次级路由模式
  {
    path: "/scan-ticket/:orderId",
    name: "scan-ticket",
    component: () =>
      import(
        /* webpackChunkName: "scan-ticket" */ "../views/scan-ticket/index.vue"
      ),
    meta: {
      title: language === "cn" ? cn["orderQRCode"] : en["orderQRCode"], //订单二维码
    },
  },
  // 最新路由模式
  {
    path: "/qr/:orderId",
    name: "qr",
    component: () =>
      import(
        /* webpackChunkName: "scan-ticket" */ "../views/scan-ticket/index.vue"
      ),
    meta: {
      title: language === "cn" ? cn["orderQRCode"] : en["orderQRCode"], //订单二维码
    },
  },
  // 旅游产品详情路由
  {
    path: "/qrt/:orderId",
    name: "qrt",
    component: () =>
      import(
        /* webpackChunkName: "tour-product-detail" */ "../views/qrt/index.vue"
      ),
    meta: {
      title:
        language === "cn" ? cn["tourProductDetail"] : en["tourProductDetail"], //旅游产品详情
    },
  },
  {
    path: "/coach-message/:orderId",
    name: "coach-message",
    component: () =>
      import(
        /* webpackChunkName: "coach-message" */ "../views/coach-message/index.vue"
      ),
    meta: {
      title: language === "cn" ? cn["coachMessage"] : en["coachMessage"], //教练短信
    },
  },
  {
    path: "/home",
    component: Layout,
    children: [
      {
        path: "person-center",
        name: "person-center",
        component: () =>
          import(
            /* webpackChunkName: "person-center" */ "../views/login/person-center.vue"
          ),
        meta: {
          title: language === "cn" ? cn["userCenter"] : en["userCenter"], //"个人中心"
          hidden: true,
        },
      },
      {
        path: "no-permission",
        name: "no-permission",
        component: () =>
          import(
            /* webpackChunkName: "person-center" */ "../views/login/no-permission.vue"
          ),
        meta: {
          title: "访问受限",
          hidden: true,
        },
      },
    ],
  },
  {
    path: "/app-download",
    name: "/app-download",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/login/app-download.vue"),
    meta: {
      title: "下载app",
    },
  },
  {
    path: "/print-preview",
    name: "/print-preview",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "print-preview" */ "../views/print-preview/index.vue"
      ),
    meta: {
      title: language === "cn" ? cn["reportPreview"] : en["reportPreview"], //"报表预览",
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: ErrorPage,
    meta: {
      title: language === "cn" ? cn["noPageAvailable"] : en["noPageAvailable"], //"暂无页面",
    },
  },
  {
    path: "/asset-management",
    name: "asset-management",
    component: Layout,
    meta: {
      title: language === "cn" ? cn["assetManagement"] : en["assetManagement"], //"资产管理",
      icon: "asset",
      roles: ["asset_management_agent"],
    },
    children: [
      {
        path: "cash-account",
        name: "cash-account",
        component: () =>
          import(
            /* webpackChunkName: "asset-management" */ "../views/asset-management/cash-account.vue"
          ),
        meta: {
          title:
            language === "cn" ? cn["prepaidAccount"] : en["prepaidAccount"], //"预付款账户",
          roles: ["asset_management_cash_account"],
          from: "cash-account",
        },
      },
      {
        path: "cash-allocate",
        name: "cash-allocate",
        component: () =>
          import(
            /* webpackChunkName: "asset-management" */ "../views/asset-management/cash-allocate.vue"
          ),
        meta: {
          title: language === "cn" ? cn["allocate"] : en["allocate"], //"分配",
          roles: ["asset_management_cash_allocate"],
          from: "cash-account",
          hidden: true,
        },
      },
      {
        path: "cash-recycle",
        name: "cash-recycle",
        component: () =>
          import(
            /* webpackChunkName: "asset-management" */ "../views/asset-management/cash-recycle.vue"
          ),
        meta: {
          title: language === "cn" ? cn["recover"] : en["recover"], //"回收",
          roles: ["asset_management_cash_recycle"],
          from: "cash-account",
          hidden: true,
        },
      },
      {
        path: "cash-transfer",
        name: "cash-transfer",
        component: () =>
          import(
            /* webpackChunkName: "asset-management" */ "../views/asset-management/cash-transfer.vue"
          ),
        meta: {
          title: language === "cn" ? cn["transfer"] : en["transfer"], //"转移",
          roles: ["asset_management_cash_transfer"],
          from: "cash-account",
          hidden: true,
        },
      },

      {
        path: "open-list",
        name: "open-list",
        component: () =>
          import(
            /* webpackChunkName: "asset-management" */ "../views/asset-management/open-list.vue"
          ),
        meta: {
          title: language === "cn" ? cn["buyoutAccount"] : en["buyoutAccount"], //"买断账户",
          roles: ["asset_management_stock_account"],
          from: "open-list",
        },
      },
      {
        path: "open-list-allocate",
        name: "open-list-allocate",
        component: () =>
          import(
            /* webpackChunkName: "asset-management" */ "../views/asset-management/open-list-allocate.vue"
          ),
        meta: {
          title: language === "cn" ? cn["allocate"] : en["allocate"], //"分配",
          roles: ["asset_management_stock_allocate"],
          from: "open-list",
          hidden: true,
        },
      },
      {
        path: "open-list-recycle",
        name: "open-list-recycle",
        component: () =>
          import(
            /* webpackChunkName: "asset-management" */ "../views/asset-management/open-list-recycle.vue"
          ),
        meta: {
          title: language === "cn" ? cn["recover"] : en["recover"], //"回收",
          roles: ["asset_management_stock_recycle"],
          from: "open-list",
          hidden: true,
        },
      },
      {
        path: "open-list-transfer",
        name: "open-list-transfer",
        component: () =>
          import(
            /* webpackChunkName: "asset-management" */ "../views/asset-management/open-list-transfer.vue"
          ),
        meta: {
          title: language === "cn" ? cn["transfer"] : en["transfer"], // "转移",
          roles: ["asset_management_stock_transfer"],
          from: "open-list",
          hidden: true,
        },
      },
    ],
  },
  {
    path: "/sales-management",
    name: "sales-management",
    component: Layout,
    meta: {
      title: language === "cn" ? cn["ticketSales"] : en["ticketSales"], // 车票销售
      icon: "sale",
      roles: ["sales_management_agent"],
    },
    children: [
      {
        path: "ticket-sale",
        name: "ticket-sale",
        component: () =>
          import(
            /* webpackChunkName: "sales-management" */ "../views/sales-management/ticket-sale.vue"
          ),
        meta: {
          title: language === "cn" ? cn["purchase"] : en["purchase"], // "出票",
          roles: ["sales_management_list_agent"],
          from: "ticket-sale",
        },
      },
      {
        path: "trip-preview",
        name: "trip-preview",
        component: () =>
          import(
            /* webpackChunkName: "sales-management" */ "../views/sales-management/trip-preview.vue"
          ),
        meta: {
          title:
            language === "cn"
              ? cn["ticketSalesInquiry"]
              : en["ticketSalesInquiry"], //"查询售票",
          roles: ["sales_management_trip_overview_agent"],
          from: "trip-preview",
        },
      },
      {
        path: "sale-exchange",
        name: "sale-exchange",
        component: () =>
          import(
            /* webpackChunkName: "sales-management" */ "../views/sales-management/sale-exchange.vue"
          ),
        meta: {
          title:
            language === "cn" ? cn["openTicketSales"] : en["openTicketSales"], //"open票销售",
          roles: ["open_management_sale_agent"],
          from: "sale-exchange",
        },
      },
      {
        path: "fetch-ticket",
        name: "fetch-ticket",
        component: () =>
          import(
            /* webpackChunkName: "sales-management" */ "../views/sales-management/fetch-ticket.vue"
          ),
        meta: {
          title:
            language === "cn"
              ? cn["seatAssignmentReservation"]
              : en["seatAssignmentReservation"], //"取位留位",
          roles: ["sales_management_ticket_fetch_booking_agent"],
          from: "fetch-ticket",
        },
      },
      {
        path: "booking-ticket-list",
        name: "booking-ticket-list",
        component: () =>
          import(
            /* webpackChunkName: "sales-management-booking" */ "../views/sales-management/booking-ticket-list.vue"
          ),
        meta: {
          title:
            language === "cn"
              ? cn["reservedTicketSales"]
              : en["reservedTicketSales"], //"预留票销售",
          roles: ["sales_management_booking_ticket_list_agent"],
          from: "booking-ticket-list",
        },
      },
      {
        path: "booking-ticket-details",
        name: "booking-ticket-details",
        component: () =>
          import(
            /* webpackChunkName: "sales-management-booking" */ "../views/sales-management/booking-ticket-details.vue"
          ),
        meta: {
          title:
            language === "cn"
              ? cn["reservedOrderDetails"]
              : en["reservedOrderDetails"], //"预留订单详情",
          roles: ["sales_management_booking_ticket_list_agent"],
          from: "booking-ticket-details",
          hidden: true,
        },
      },
      {
        path: "handwrite-ticket-sale",
        name: "handwrite-ticket-sale",
        component: () =>
          import(
            /* webpackChunkName: "sales-management" */ "../views/sales-management/handwrite-ticket-sale.vue"
          ),
        meta: {
          title:
            language === "cn"
              ? cn["handwrittenTicketSales"]
              : en["handwrittenTicketSales"], //"手写票销售",
          // roles: ["sales_management_list_agent"],
          roles: ["sales_management_handwrite_ticket_agent"],
          from: "handwrite-ticket-sale",
        },
      },
    ],
  },
  {
    path: "/tour-product-management",
    name: "/tour-product-management",
    component: Layout,
    meta: {
      title: language === "cn" ? cn["tourismProduct"] : en["tourismProduct"], // "旅游产品",
      icon: "wallet",
      roles: ["tour-product-management"],
    },
    children: [
      {
        path: "API-product-pack-sale",
        name: "API-product-pack-sale",
        component: () =>
          import(
            /* webpackChunkName: "tour-product-management" */ "../views/tour-product-management/API-product-pack-sale.vue"
          ),
        meta: {
          title:
            language === "cn"
              ? cn["tourismProductSales"]
              : en["tourismProductSales"], // "旅游产品销售",
          roles: ["API-product-pack-sale"],
          from: "API-product-pack-sale",
        },
      },
      {
        path: "API-product-order-list",
        name: "API-product-order-list",
        component: () =>
          import(
            /* webpackChunkName: "tour-product-management" */ "../views/tour-product-management/API-product-order-list.vue"
          ),
        meta: {
          title:
            language === "cn"
              ? cn["tourismProductOrders"]
              : en["tourismProductOrders"], // "旅游产品订单",
          roles: ["API-product-order-list"],
          from: "API-product-order-list",
        },
      },
      {
        path: "API-product-order-detail",
        name: "API-product-order-detail",
        component: () =>
          import(
            /* webpackChunkName: "tour-product-management" */ "../views/tour-product-management/API-product-order-detail.vue"
          ),
        meta: {
          title:
            language === "cn"
              ? cn["tourismProductOrderDetails"]
              : en["tourismProductOrderDetails"], //"旅游产品订单详情",
          roles: ["API-product-order-list"],
          from: "API-product-order-list",
          hidden: true,
        },
      },
    ],
  },
  {
    path: "/order-tickets-management",
    name: "order-tickets-management",
    component: Layout,
    meta: {
      title:
        language === "cn"
          ? cn["orderTicketManagement"]
          : en["orderTicketManagement"], //"订单车票管理",
      icon: "price",
      roles: ["order_ticket_managements_agent"],
    },
    children: [
      {
        path: "order-list-finance",
        name: "order-list-finance",
        component: () =>
          import(
            /* webpackChunkName: "order-tickets-management" */ "../views/order-tickets-management/order-list-finance.vue"
          ),
        meta: {
          title: language === "cn" ? cn["orderInquiry"] : en["orderInquiry"], //"订单查询",
          roles: ["order_tickets_agent_management_order"],
          from: "order-list-finance",
        },
      },
      {
        path: "order-list-finance-detail",
        name: "order-list-finance-detail",
        component: () =>
          import(
            /* webpackChunkName: "order-tickets-management" */ "../views/order-tickets-management/order-list-finance-detail.vue"
          ),
        meta: {
          title: language === "cn" ? cn["orderDetails"] : en["orderDetails"], //"订单详情",
          roles: ["order_tickets_agent_management_order"],
          from: "order-list-finance",
          hidden: true,
        },
      },
      {
        path: "ticket-inquiry",
        name: "ticket-inquiry",
        component: () =>
          import(
            /* webpackChunkName: "order-tickets-management" */ "../views/order-tickets-management/ticket-inquiry.vue"
          ),
        meta: {
          title: language === "cn" ? cn["ticketInquiry"] : en["ticketInquiry"], //"车票查询",
          roles: ["order_tickets_agent_management_tickets"],
          from: "ticket-inquiry",
        },
      },
      {
        path: "ticket-inquiry-details",
        component: () =>
          import(
            /* webpackChunkName: "order-tickets-management" */ "../views/order-tickets-management/ticket-inquiry-details.vue"
          ),
        name: "ticket-inquiry-details",
        meta: {
          title:
            language === "cn"
              ? cn["ticketDetailsLabel"]
              : en["ticketDetailsLabel"], //"车票详情",
          roles: ["order_tickets_agent_management_tickets"],
          from: "ticket-inquiry",
          hidden: true,
        },
      },
      {
        path: "package-ticket-detail",
        name: "package-ticket-detail",
        component: () =>
          import(
            /* webpackChunkName: "ticket-inquiry" */ "../views/order-tickets-management/package-ticket-detail.vue"
          ),
        meta: {
          title:
            language === "cn"
              ? cn["baggageOrSupplementTicketDetail"]
              : en["baggageOrSupplementTicketDetail"], //"行李票/补价票详情",
          roles: ["order_tickets_agent_management_tickets"],
          from: "ticket-inquiry",
          hidden: true,
        },
      },
      {
        path: "ticket-rebook",
        name: "ticket-rebook",
        component: () =>
          import(
            /* webpackChunkName: "order-tickets-management" */ "../views/order-tickets-management/ticket-rebook.vue"
          ),
        meta: {
          title:
            language === "cn"
              ? cn["ticketRescheduling"]
              : en["ticketRescheduling"], //"车票改签",
          roles: ["order_tickets_agent_management_tickets"],
          from: "order-tickets-management",
          hidden: true,
        },
      },
      {
        path: "message-list",
        name: "message-list",
        component: () =>
          import(
            /* webpackChunkName: "order-tickets-management" */ "../views/order-tickets-management/message-list/index.vue"
          ),
        meta: {
          title: language === "cn" ? cn["smsManagement"] : en["smsManagement"], //"短信管理",
          roles: ["order_tickets_agent_management_message"],
          from: "message-list",
        },
      },
      {
        path: "message-details",
        name: "message-details",
        component: () =>
          import(
            /* webpackChunkName: "message-details" */ "../views/order-tickets-management/message-details.vue"
          ),
        meta: {
          title: language === "cn" ? cn["smsDetails"] : en["smsDetails"], //"短信详情",
          roles: ["order_tickets_management_message"],
          from: "message-list",
          hidden: true,
        },
      },
    ],
  },
  {
    path: "/report-management",
    name: "/report-management",
    component: Layout,
    meta: {
      title:
        language === "cn" ? cn["reportManagement"] : en["reportManagement"], //"报表管理",
      icon: "wallet",
      roles: ["report_management_agent"],
    },
    children: [
      {
        path: "download-list",
        name: "download-list",
        component: () =>
          import(
            /* webpackChunkName: "report-management" */ "../views/report-management/download-list.vue"
          ),
        meta: {
          title: "预约下载",
          roles: ["report_management_agent"],
          from: "download-list",
        },
      },
      {
        path: "settlement-report",
        meta: {
          title:
            language === "cn" ? cn["settlementReport"] : en["settlementReport"], //"结算报表",
          roles: ["report_management_settlement_agent"],
          from: "settlement-report",
        },
        children: [
          {
            path: "settlement-a",
            name: "settlement-a",
            component: () =>
              import(
                /* webpackChunkName: "settlement-management" */ "../views/report-management/settlement-report/settlement-a.vue"
              ),
            meta: {
              title:
                language === "cn" ? cn["soldByOperator"] : en["soldByOperator"], //"操作员售出",
              roles: ["report_management_settlement/settlement-a"],
              from: "settlement-a",
            },
          },
          {
            path: "settlement-b",
            name: "settlement-b",
            component: () =>
              import(
                /* webpackChunkName: "settlement-management" */ "../views/report-management/settlement-report/settlement-b.vue"
              ),
            meta: {
              title:
                language === "cn" ? cn["refundRecords"] : en["refundRecords"], //"退票记录",
              roles: ["report_management_settlement/settlement-b"],
              from: "settlement-b",
            },
          },
          {
            path: "settlement-h",
            name: "settlement-h",
            component: () =>
              import(
                /* webpackChunkName: "settlement-management" */ "../views/report-management/settlement-report/settlement-h.vue"
              ),
            meta: {
              title:
                language === "cn"
                  ? cn["agentRevenueReport"]
                  : en["agentRevenueReport"], //"代理营收报表",
              roles: ["report_management/settlement-h"],
              from: "settlement-h",
            },
          },
          {
            path: "settlement-j",
            name: "settlement-j",
            component: () =>
              import(
                /* webpackChunkName: "settlement-management" */ "../views/report-management/settlement-report/settlement-j.vue"
              ),
            meta: {
              title:
                language === "cn"
                  ? cn["agentInventoryReport"]
                  : en["agentInventoryReport"], //"代理库存表",
              roles: ["report_management/settlement-j"],
              from: "settlement-j",
            },
          },
          {
            path: "settlement-t",
            name: "settlement-t",
            component: () =>
              import(
                /* webpackChunkName: "settlement-management" */ "../views/report-management/settlement-report/settlement-t.vue"
              ),
            meta: {
              title:
                language === "cn"
                  ? cn["groupTicketReport"]
                  : en["groupTicketReport"], //"团体票报表",
              roles: ["report_management/settlement-t"],
              from: "settlement-t",
            },
          },
        ],
      },
      {
        path: "business-report",
        meta: {
          title:
            language === "cn" ? cn["businessReport"] : en["businessReport"], //"业务报表",
          roles: ["report_management_business_agent"],
          from: "business-report",
        },
        children: [
          {
            path: "business-i",
            name: "business-i",
            component: () =>
              import(
                /* webpackChunkName: "business-report" */ "../views/report-management/business-report/business-i.vue"
              ),
            meta: {
              title:
                language === "cn"
                  ? cn["universalReportSales"]
                  : en["universalReportSales"], //"万能报表销售",
              roles: ["report_management_business_i_agent"],
              from: "business-i",
            },
          },
          {
            path: "business-j",
            name: "business-j",
            component: () =>
              import(
                /* webpackChunkName: "business-report" */ "../views/report-management/business-report/business-j.vue"
              ),
            meta: {
              title:
                language === "cn"
                  ? cn["universalReportSeat"]
                  : en["universalReportSeat"], //"万能报表取位",
              roles: ["report_management_business_j_agent"],
              from: "business-j",
            },
          },
          {
            path: "seat-hold-stats",
            name: "seat-hold-stats",
            component: () =>
              import(
                /* webpackChunkName: "report-management" */ "../views/report-management/business-report/seat-hold-stats.vue"
              ),
            meta: {
              title:
                language === "cn" ? cn["seatHoldStats"] : en["seatHoldStats"], //"座位预留统计"
              roles: ["report_management_business_seat_hold_stats"],
              from: "seat-hold-stats",
            },
          },
        ],
      },
      {
        path: "prepay-report",
        meta: {
          title: language === "cn" ? cn["prepaidReport"] : en["prepaidReport"], //"预付款报表",
          roles: ["report_management_prepay_agent"],
          from: "prepay-report",
        },
        children: [
          {
            path: "prepay-a",
            name: "prepay-a",
            component: () =>
              import(
                /* webpackChunkName: "prepay-management" */ "../views/report-management/prepay-report/prepay-a.vue"
              ),
            meta: {
              title:
                language === "cn"
                  ? cn["appreciationRecord"]
                  : en["appreciationRecord"], //充值记录表
              roles: ["report_management_prepay_a_agent"],
              from: "prepay-a",
            },
          },
          {
            path: "prepay-c",
            name: "prepay-c",
            component: () =>
              import(
                /* webpackChunkName: "prepay-management" */ "../views/report-management/prepay-report/prepay-c.vue"
              ),
            meta: {
              title:
                language === "cn"
                  ? cn["balanceTransfer"]
                  : en["balanceTransfer"], // 额度转移表
              roles: ["report_management_prepay_c_agent"],
              from: "prepay-c",
            },
          },
          {
            path: "prepay-d",
            name: "prepay-d",
            component: () =>
              import(
                /* webpackChunkName: "prepay-management" */ "../views/report-management/prepay-report/prepay-d.vue"
              ),
            meta: {
              title:
                language === "cn"
                  ? cn["agentRemainingPrepaid"]
                  : en["agentRemainingPrepaid"], //"代理剩余预付款",
              roles: ["report_management_prepay_d_agent"],
              from: "prepay-d",
            },
          },
          {
            path: "prepay-e",
            name: "prepay-e",
            component: () =>
              import(
                /* webpackChunkName: "prepay-management" */ "../views/report-management/prepay-report/prepay-e.vue"
              ),
            meta: {
              title:
                language === "cn"
                  ? cn["agentRemainingPrepaidSummary"]
                  : en["agentRemainingPrepaidSummary"], //"预付款剩余汇总",
              roles: ["report_management_prepay_e_agent"],
              from: "prepay-e",
            },
          },
        ],
      },
    ],
  },
];
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
router.beforeResolve((to: any, from) => {
  const { userStore } = usePiniaStore();
  const token = localStorage.getItem("token_value");

  // 跳转到登录页面或无权限页面前，保存之前的菜单操作记录
  if (to.path === "/login" || to.path === "/home/no-permission") {
    return;
  }
  const { pathname, search } = window.location;

  if (token === null) {
    // 当前无登陆态，记录当前路由URL
    sessionStorage.setItem("redirectUrl", pathname + search);
    return;
  }

  // 权限检查：如果用户已登录，检查是否有访问当前路由的权限
  if (token && userStore.roles.length > 0 && to.meta?.roles?.length > 0) {
    // 检查当前路由是否有权限
    if (!userStore.roles.includes(to.meta?.roles[0])) {
      // 重定向到无权限页面
      router.replace("/home/no-permission");
      return;
    }
  }

  if (to.meta.hidden) {
    userStore.addBreadcrumbList({
      title: to.meta.title,
      path: to.path,
      name: to.name,
    });
    if (to.path === "/home/person-center") {
      to.meta.from = from.meta.from;
    }
  } else {
    const list = to.matched.reduce(
      (
        val: any[],
        item: {
          meta: {
            title: string;
          };
          path: string;
          name: string;
        }
      ) => {
        if (item.path) {
          val.push({
            title: item.meta.title,
            path: item.path,
            name: item.name,
          });
        }
        return val;
      },
      []
    );
    userStore.updateSelectMenus(to.name);
    userStore.updateBreadcrumbList(list);
  }
});
router.onError((error) => {
  // 在线上页面已经打开的情况下，重新打包部署了前端项目。每次打包，js文件的hash值都会发生改变,就会产生资源加载错误
  // 在路由守卫的错误回调中 筛选出上述场景 重新加载下页面即可
  const pattern = /Loading chunk chunk-(.*)+ failed/g;
  const staticFilesErr = /Failed to load resource/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const isStaticFilesLoadFailed = error.message.match(staticFilesErr);
  if (isChunkLoadFailed || isStaticFilesLoadFailed) {
    location.reload();
  }
});

export default router;
